import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { UsersManagementComponent } from './users-management/users-management.component';
import { AddusermanagementComponent } from './addusermanagement/addusermanagement.component';
import { MastermoduleComponent } from './mastermodule/mastermodule.component';
import { AccessmanagementComponent } from './accessmanagement/accessmanagement.component';
//import { DiseasemanagementComponent } from './diseasemanagement/diseasemanagement.component';
import { SpeciesmanagementComponent } from './speciesmanagement/speciesmanagement.component';
import { BreedsmanagementComponent } from './breedsmanagement/breedsmanagement.component';
import { StockmanagementComponent } from './stockmanagement/stockmanagement.component';
//import { VaccinemanagementComponent } from './vaccinemanagement/vaccinemanagement.component';
/*import { DewormingManagementComponent } from './deworming-management/deworming-management.component';
import { EditdewormingmanagementComponent } from './editmodulemanagement/editdewormingmanagement/editdewormingmanagement.component';
import { AddDewormingmanagementComponent } from './addmodulemanagement/add-dewormingmanagement/add-dewormingmanagement.component';
import { ViewdewormingmanagementComponent } from './viewmodulemanagement/viewdewormingmanagement/viewdewormingmanagement.component';*/
import { FarmsmanagementComponent } from './farmsmanagement/farmsmanagement.component';
//import {AddDiseaseManagementComponent} from './addmodulemanagement/add-disease-management/add-disease-management.component';
import { AddspeciesmanagementComponent } from './addmodulemanagement/addspeciesmanagement/addspeciesmanagement.component';
import { AddbreedsmanagementComponent } from './addmodulemanagement/addbreedsmanagement/addbreedsmanagement.component';
import { AddstockmanagementComponent } from './addmodulemanagement/addstockmanagement/addstockmanagement.component';
//import { AddvaccinemanagementComponent } from './addmodulemanagement/addvaccinemanagement/addvaccinemanagement.component';
import { AddfarmsmanagementComponent } from './addmodulemanagement/addfarmsmanagement/addfarmsmanagement.component';
//import { ViewdiseasemanagementComponent } from './viewmodulemanagement/viewdiseasemanagement/viewdiseasemanagement.component';
import { ViewspeciesmanagementComponent } from './viewmodulemanagement/viewspeciesmanagement/viewspeciesmanagement.component';
import { ViewbreedsmanagementComponent } from './viewmodulemanagement/viewbreedsmanagement/viewbreedsmanagement.component';
import { ViewstockmanagementComponent } from './viewmodulemanagement/viewstockmanagement/viewstockmanagement.component';
//import { ViewvaccinemanagementComponent } from './viewmodulemanagement/viewvaccinemanagement/viewvaccinemanagement.component';
import { ViewfarmsmanagementComponent } from './viewmodulemanagement/viewfarmsmanagement/viewfarmsmanagement.component';
import { CreateaccessmanagementComponent } from './addaccessmanagement/createaccessmanagement/createaccessmanagement.component';
import { CreateaccessmanagementoneComponent } from './addaccessmanagement/createaccessmanagementone/createaccessmanagementone.component';
import { EditaccessmanagementComponent } from './editaccessmanagement/editaccessmanagement/editaccessmanagement.component';
import { EditaccessmanagementoneComponent } from './editaccessmanagement/editaccessmanagementone/editaccessmanagementone.component';
import { ViewaccessmanagementComponent } from './viewaccessmanagement/viewaccessmanagement.component';
//import {​​​​​​​​EditDiseaseManagementComponent}​​​​​​​​ from'./editmodulemanagement/edit-disease-management/edit-disease-management.component';
import { EditspeciesmanagementComponent } from './editmodulemanagement/editspeciesmanagement/editspeciesmanagement.component';
import { EditbreedsmanagementComponent } from './editmodulemanagement/editbreedsmanagement/editbreedsmanagement.component';
import { EditstockmanagementComponent } from './editmodulemanagement/editstockmanagement/editstockmanagement.component';
//import {​​​​​​​​ EditvaccinemanagementComponent }​​​​​​​​ from'./editmodulemanagement/editvaccinemanagement/editvaccinemanagement.component';
import { EditfarmsmanagementComponent } from './editmodulemanagement/editfarmsmanagement/editfarmsmanagement.component';
import { StockmanagementanimalsComponent } from './stockmanagementanimals/stockmanagementanimals.component';
import { AnimalmanagementmoduleComponent } from './animalmanagementmodule/animalmanagementmodule.component';
import { RottweilerDogsAnimalmanagementComponent } from './animalmodule/rottweiler-dogs-animalmanagement/rottweiler-dogs-animalmanagement.component';
import { ReportmanagementComponent } from './ReportManagement/reportmanagement/reportmanagement.component';
import { MonthlyCalculationComponent } from './ReportManagement/monthly-calculation/monthly-calculation.component';
import { MonthlyCalculationPercentageComponent } from './ReportManagement/monthly-calculation-percentage/monthly-calculation-percentage.component';
import { CumulativeAndAnnualCalculationComponent } from './ReportManagement/cumulative-and-annual-calculation/cumulative-and-annual-calculation.component';
import { ComparisonOfAnnualCalculationComponent } from './ReportManagement/comparison-of-annual-calculation/comparison-of-annual-calculation.component';
import { GenerationOfGraphsComponent } from './ReportManagement/generation-of-graphs/generation-of-graphs.component';
import { StockLevelDatabaseComponent } from './ReportManagement/stock-level-database/stock-level-database.component';
import { EditusermanagementComponent } from './editusermanagement/editusermanagement.component';
import { ViewusermanagementComponent } from './viewusermanagement/viewusermanagement.component';
import { AddAnimalDiseaseComponent } from './animalmodule/AddAnimalModule/add-animal-disease/add-animal-disease.component';
import { EditAnimalDiseaseComponent } from './animalmodule/EditAnimalModule/edit-animal-disease/edit-animal-disease.component';
import { ViewAnimalDiseaseComponent } from './animalmodule/ViewAnimalModule/view-animal-disease/view-animal-disease.component';
import { AddAnimalVaccineComponent } from './animalmodule/AddAnimalModule/add-animal-vaccine/add-animal-vaccine.component';
import { EditAnimalVaccineComponent } from './animalmodule/EditAnimalModule/edit-animal-vaccine/edit-animal-vaccine.component';
import { ViewAnimalVaccineComponent } from './animalmodule/ViewAnimalModule/view-animal-vaccine/view-animal-vaccine.component';
import { AddAnimalSamplesComponent } from './animalmodule/AddAnimalModule/add-animal-samples/add-animal-samples.component';
import { AddAnimalDiagnosticComponent } from './animalmodule/AddAnimalModule/add-animal-diagnostic/add-animal-diagnostic.component';
import { AddAnimalDewormingComponent } from './animalmodule/AddAnimalModule/add-animal-deworming/add-animal-deworming.component';
import { EditAnimalSamplesComponent } from './animalmodule/EditAnimalModule/edit-animal-samples/edit-animal-samples.component';
import { EditAnimalDiagnosticComponent } from './animalmodule/EditAnimalModule/edit-animal-diagnostic/edit-animal-diagnostic.component';
import { EditAnimalDewormingComponent } from './animalmodule/EditAnimalModule/edit-animal-deworming/edit-animal-deworming.component';
import { ViewAnimalDewormingComponent } from './animalmodule/ViewAnimalModule/view-animal-deworming/view-animal-deworming.component';
import { ViewAnimalDiagnosticComponent } from './animalmodule/ViewAnimalModule/view-animal-diagnostic/view-animal-diagnostic.component';
import { ViewAnimalSamplesComponent } from './animalmodule/ViewAnimalModule/view-animal-samples/view-animal-samples.component';
import { AddAnimalDeathComponent } from './animalmodule/AddAnimalModule/add-animal-death/add-animal-death.component';
import { AddAnimalGeneralComponent } from './animalmodule/AddAnimalModule/add-animal-general/add-animal-general.component';
import { EditAnimalDeathComponent } from './animalmodule/EditAnimalModule/edit-animal-death/edit-animal-death.component';
import { EditAnimalGeneralComponent } from './animalmodule/EditAnimalModule/edit-animal-general/edit-animal-general.component';
import { ViewAnimalGeneralComponent } from './animalmodule/ViewAnimalModule/view-animal-general/view-animal-general.component';
import { ViewAnimalDeathComponent } from './animalmodule/ViewAnimalModule/view-animal-death/view-animal-death.component';
import { DashboardGraphComponent } from './dashboard-graph/dashboard-graph.component';
import { ViewagegroupComponent } from './viewmodulemanagement/viewagegroup/viewagegroup.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { AuthGuard } from './auth.guard';
import { ProductGuard } from './product.guard';
import { ResolverService } from '../app/resolver.service';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'resetpassword', component: ResetpasswordComponent },
  {
    path: 'dashboard', component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '', // child route path
        component: DashboardGraphComponent, // child route component that the router renders
      },
      {
        path: 'mastermodule', // child route path
        component: MastermoduleComponent, // child route component that the router renders
      },
      {
        path: 'usermanagement',
        component: UsersManagementComponent,
        canActivate: [ProductGuard],
        // another child route component that the router renders
      },
      {
        path: 'addusermanagement',
        component: AddusermanagementComponent,
      },
      {
        path: 'accessmanagement',
        component: AccessmanagementComponent,
        canActivate: [ProductGuard],
        // another child route component that the router renders
      },
      /* {
         path:'diseasemanagement',
         component:DiseasemanagementComponent, 
       },*/
      {
        path: 'speciesmanagement',
        component: SpeciesmanagementComponent,
        // another child route component that the router renders
      },
      {
        path: 'breedsmanagement',
        component: BreedsmanagementComponent,
        // another child route component that the router renders
      },
      {
        path: 'stockmanagement',
        component: StockmanagementComponent, // another child route component that the router renders
      },
      /*{
        path:'vaccinemanagement',
        component:VaccinemanagementComponent, // another child route component that the router renders
      },*/
      {
        path: 'farmsmanagement',
        component: FarmsmanagementComponent, // another child route component that the router renders
      },
      /*{
        path:'adddiseasemanagement',
        component:AddDiseaseManagementComponent, // another child route component that the router renders
      }, */
      {
        path: 'addspeciesmanagement',
        component: AddspeciesmanagementComponent, // another child route component that the router renders
      },
      {
        path: 'addbreedsmanagement',
        component: AddbreedsmanagementComponent, // another child route component that the router renders
      },
      {
        path: 'addstockmanagement',
        component: AddstockmanagementComponent, // another child route component that the router renders
      },
      /*{
        path:'addvaccinemanagement',
        component:AddvaccinemanagementComponent, // another child route component that the router renders
      }, */
      {
        path: 'addfarmsmanagement',
        component: AddfarmsmanagementComponent, // another child route component that the router renders
      },
      /*{
        path:'viewdiseasemanagement',
        component:ViewdiseasemanagementComponent, 
      }, */
      {
        path: 'viewspeciesmanagement',
        component: ViewspeciesmanagementComponent,
      },
      {
        path: 'viewbreedsmanagement',
        component: ViewbreedsmanagementComponent,
      },
      {
        path: 'viewstockmanagement',
        component: ViewstockmanagementComponent,
      },
      /* {
         path:'viewvaccinemanagement',
         component:ViewvaccinemanagementComponent, 
       }, */
      {
        path: 'viewfarmsmanagement',
        component: ViewfarmsmanagementComponent,
      },
      {
        path: 'viewfarmsmanagement',
        component: ViewfarmsmanagementComponent,
      },
      {
        path: 'createaccessmanagement',
        component: CreateaccessmanagementComponent,
      },
      {
        path: 'createaccessmanagementone',
        component: CreateaccessmanagementoneComponent,
      },
      {
        path: 'editaccessmanagement',
        component: EditaccessmanagementComponent,
      },
      {
        path: 'editaccessmanagementone',
        component: EditaccessmanagementoneComponent,
      },
      {
        path: 'viewaccessmanagement',
        component: ViewaccessmanagementComponent,
      },
      {
        path: 'editfarmsmanagement',
        component: EditfarmsmanagementComponent,
      },
      /*{​​​​​​​​
        path:'editdiseasemanagement',
        component:EditDiseaseManagementComponent, // another child route component that the router renders
      }​​​​​​​​, */
      {
        path: 'editspeciesmanagement',
        component: EditspeciesmanagementComponent, // another child route component that the router renders
      },
      {
        path: 'editbreedsmanagement',
        component: EditbreedsmanagementComponent,

        // another child route component that the router renders
      },
      {
        path: 'editstockmanagement',
        component: EditstockmanagementComponent, // another child route component that the router renders
      },
      /*{​​​​​​​​
  path:'editvaccinemanagement',
  component:EditvaccinemanagementComponent, // another child route component that the router renders
      }​​​​​​​​,*/
      {
        path: 'stock_man_animal', // child route path
        component: StockmanagementanimalsComponent, // child route component that the router renders
      },
      {
        path: 'animalmanagement', // child route path
        component: AnimalmanagementmoduleComponent, // child route component that the router renders
      },
      /*{
        path:'DewormingManagement', // child route path
        component:DewormingManagementComponent , // child route component that the router renders
      },
      {
        path:'AddDewormingManagement', // child route path
        component:AddDewormingmanagementComponent , // child route component that the router renders
      },
      {
        path:'EditDewormingManagement', // child route path
        component:EditdewormingmanagementComponent , // child route component that the router renders
      },
      {
        path:'ViewDewormingManagement', // child route path
        component:ViewdewormingmanagementComponent , // child route component that the router renders
      },*/
      {
        path: 'RottweilerDogsAnimalmanagement', // child route path
        component: RottweilerDogsAnimalmanagementComponent, // child route component that the router renders
      },
      {
        path: 'Reportmanagement', // child route path
        component: ReportmanagementComponent, // child route component that the router renders
      },
      {
        path: 'MonthlyCalculation', // child route path
        component: MonthlyCalculationComponent, // child route component that the router renders
      },
      {
        path: 'MonthlyCalculationPercentage', // child route path
        component: MonthlyCalculationPercentageComponent, // child route component that the router renders
      },
      {
        path: 'CumulativeAndAnnualCalculation', // child route path
        component: CumulativeAndAnnualCalculationComponent, // child route component that the router renders
      },
      {
        path: 'ComparisonOfAnnualCalculation', // child route path
        component: ComparisonOfAnnualCalculationComponent, // child route component that the router renders
      },
      {
        path: 'GenerationOfGraphs', // child route path
        component: GenerationOfGraphsComponent, // child route component that the router renders
      },
      {
        path: 'StockLevelDatabase', // child route path
        component: StockLevelDatabaseComponent, // child route component that the router renders
      },
      {
        path: 'EditUserManagement', // child route path
        component: EditusermanagementComponent, // child route component that the router renders
      },
      {
        path: 'ViewUserManagement', // child route path
        component: ViewusermanagementComponent, // child route component that the router renders
      },

      {
        path: 'AddAnimalDisease',
        component: AddAnimalDiseaseComponent,
      },
      {
        path: 'EditAnimalDisease', // child route path
        component: EditAnimalDiseaseComponent, // child route component that the router renders
      },
      {
        path: 'ViewAnimalDisease', // child route path
        component: ViewAnimalDiseaseComponent, // child route component that the router renders
      },
      {
        path: 'AddAnimalVaccine',
        component: AddAnimalVaccineComponent,
      },
      {
        path: 'EditAnimalVaccine',
        component: EditAnimalVaccineComponent,
      },
      {
        path: 'ViewAnimalVaccine',
        component: ViewAnimalVaccineComponent,
      },

      {
        path: 'AddAnimalSamples',
        component: AddAnimalSamplesComponent,
      },
      {
        path: 'AddAnimalDiagnostic',
        component: AddAnimalDiagnosticComponent,
      },
      {
        path: 'AddAnimalDeworming',
        component: AddAnimalDewormingComponent,
      },
      {
        path: 'EditAnimalSamples',
        component: EditAnimalSamplesComponent,
      },
      {
        path: 'EditAnimalDiagnostic',
        component: EditAnimalDiagnosticComponent,
      },
      {
        path: 'EditAnimalDeworming',
        component: EditAnimalDewormingComponent,
      },
      {
        path: 'ViewAnimalDeworming',
        component: ViewAnimalDewormingComponent,
      },
      {
        path: 'ViewAnimalDiagnostic',
        component: ViewAnimalDiagnosticComponent,
      },
      {
        path: 'ViewAnimalSamples',
        component: ViewAnimalSamplesComponent,
      },
      {
        path: 'AddAnimalDeath',
        component: AddAnimalDeathComponent,
      },
      {
        path: 'AddAnimalGeneral',
        component: AddAnimalGeneralComponent,
      },
      {
        path: 'EditAnimalDeath',
        component: EditAnimalDeathComponent,
      },
      {
        path: 'EditAnimalGeneral',
        component: EditAnimalGeneralComponent,
      },
      {
        path: 'ViewAnimalGeneral',
        component: ViewAnimalGeneralComponent,
      },
      {
        path: 'ViewAnimalDeath',
        component: ViewAnimalDeathComponent,
      },
      {
        path: 'viewagegroup',
        component: ViewagegroupComponent,
      },

    ],

  },
  { path: "**", redirectTo: "login" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routingcomponents = [DashboardComponent, LoginComponent, MastermoduleComponent, UsersManagementComponent, AddusermanagementComponent, AccessmanagementComponent, BreedsmanagementComponent, SpeciesmanagementComponent, FarmsmanagementComponent, StockmanagementComponent, AddspeciesmanagementComponent, AddbreedsmanagementComponent, AddstockmanagementComponent, AddfarmsmanagementComponent, ViewaccessmanagementComponent, ViewspeciesmanagementComponent, ViewbreedsmanagementComponent, ViewstockmanagementComponent, ViewfarmsmanagementComponent, CreateaccessmanagementComponent, CreateaccessmanagementoneComponent, EditaccessmanagementComponent, EditaccessmanagementoneComponent, EditspeciesmanagementComponent, EditbreedsmanagementComponent, EditstockmanagementComponent, EditfarmsmanagementComponent, StockmanagementanimalsComponent, AnimalmanagementmoduleComponent, RottweilerDogsAnimalmanagementComponent,
  ReportmanagementComponent,
  MonthlyCalculationComponent,
  MonthlyCalculationPercentageComponent,
  CumulativeAndAnnualCalculationComponent,
  ComparisonOfAnnualCalculationComponent,
  GenerationOfGraphsComponent,
  StockLevelDatabaseComponent, EditusermanagementComponent, ViewusermanagementComponent, AddAnimalDiseaseComponent, EditAnimalDiseaseComponent, ViewAnimalDiseaseComponent, AddAnimalVaccineComponent, EditAnimalVaccineComponent, ViewAnimalVaccineComponent, AddAnimalSamplesComponent, AddAnimalDiagnosticComponent, AddAnimalDewormingComponent, EditAnimalSamplesComponent, EditAnimalDiagnosticComponent, EditAnimalDewormingComponent, ViewAnimalDewormingComponent, ViewAnimalDiagnosticComponent, ViewAnimalSamplesComponent,
  AddAnimalDeathComponent, AddAnimalGeneralComponent, EditAnimalDeathComponent, EditAnimalGeneralComponent, ViewAnimalGeneralComponent, ViewAnimalDeathComponent, DashboardGraphComponent, ViewagegroupComponent, ResetpasswordComponent
]

